'use client';
import classNames from 'classnames';
import { useState } from 'react';
import { BaseTranslations } from '../../../baseTranslations';
import { useCmsClientContext } from '../../../utils/cmsPageContext';
import { getClientTranslations } from '../../../utils/translations/getClientTranslations';

type Checkbox = {
  onClick?: () => void;
  label?: string | React.ReactNode;
  size?: string;
  containerClass?: string;
  defaultValue?: boolean;
};

export const Checkbox: React.FC<Checkbox> = ({
  onClick,
  label,
  size = 'lg:size-6 size-5',
  containerClass = '',
  defaultValue = false,
}: Checkbox) => {
  const [isChecked, setIsChecked] = useState(defaultValue);
  const context = useCmsClientContext();
  const staticText = getClientTranslations(BaseTranslations, context);

  const toggleCheckbox = () => {
    setIsChecked(!isChecked);
    onClick && onClick();
  };

  return (
    <div
      className="flex gap-2"
      role="button"
      tabIndex={0}
      onClick={toggleCheckbox}
    >
      <div
        className={classNames(
          'flex shrink-0 cursor-pointer select-none items-center justify-center overflow-hidden rounded',
          size,
          containerClass,
          isChecked
            ? 'bg-primary-800'
            : 'border border-gray-400 bg-transparent',
        )}
      >
        <span className="material-symbols-outlined text-white">
          {isChecked ? staticText.check : ''}
        </span>
      </div>
      {!!label && (
        <p className="font-medium text-gray-700 text-xs md:text-sm">{label}</p>
      )}
    </div>
  );
};
